export default {

    isIe11orBelow() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE '); // IE 10 or older
        var trident = ua.indexOf('Trident/'); //IE 11

        return msie > 0 || trident > 0;
    },

    isIe9orBelow() {
        if (document.documentMode && document.documentMode <= 9)
            return true;
        else
            return false;
    },

    isEdge() {
        return /Edge/.test(navigator.userAgent);
    },

    isSafari() {
        return navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0;
    },

    isIOS() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
    },

    isAndroid() {
        return /(android)/i.test(navigator.userAgent);
    }
}




// WEBPACK FOOTER //
// ./js/utils/BrowserDetect.js